import {useActiveSubstanceDrugContext} from '@/shared/contexts/active-substance-drug'
import {Badge, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuHistory, LuInfo, LuPillBottle, LuSyringe} from 'react-icons/lu'

export function SubstanceDrawerTabsList() {
  const {t} = useTranslate('common')
  const {activeSubstanceDrug, tradeNames} = useActiveSubstanceDrugContext()

  return (
    <Tabs.List>
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>

      <Tabs.Trigger value="medication-profiles" data-e2e="medication-profiles-trigger">
        <LuSyringe />
        {t('medicine_forms')}
        <Badge size="xs">{activeSubstanceDrug.medicationProfiles?.length || 0}</Badge>
      </Tabs.Trigger>

      <Tabs.Trigger value="trade-names" data-e2e="trade-names-trigger">
        <LuPillBottle />
        {t('trade_names')}
        <Badge size="xs">{tradeNames?.length || 0}</Badge>
      </Tabs.Trigger>

      <Tabs.Trigger value="history" data-e2e="history-trigger">
        <LuHistory />
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
